import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowsersessionViewerComponent} from './browsersessionviewer/browsersessionviewer.component';
import {ArtifactComponent} from './browsersessionviewer/artifact.component';
import {ScreenshotArtifactComponent} from './browsersessionviewer/screenshot-artifact.component';
import {SeleniumActionArtifactComponent} from './browsersessionviewer/selenium-action-artifact.component';
import {PortalModule} from '@angular/cdk/portal';
import {StatedataViewerComponent} from './statedataviewer/statedataviewer.component';
import {ScreenshotModule} from '../components/screenshot/screenshot.module';
import {WebmateBrowserModule} from '../components/browser/webmate-browser.module';
import {StateModule} from '../components/state/state.module';
import {SelectButtonModule} from 'primeng/selectbutton';
import {AvatarModule} from '../components/avatar/avatar.module';
import {ButtonModule} from 'primeng/button';
import {FileUploadModule} from 'primeng/fileupload';
import {InputTextModule} from 'primeng/inputtext';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {SelectModule} from 'primeng/select';
import {TextareaModule} from 'primeng/textarea';
import {IssueReporterComponent} from '@webmate-web-core/shared/tools/issueexporter/issue-reporter.component';
import {AccordionModule} from 'primeng/accordion';
import {CheckboxModule} from 'primeng/checkbox';
import {GenericTestDialogComponent} from '@webmate-web-core/shared/tools/generic-test-template/generic-test-dialog.component';
import {TooltipModule} from 'primeng/tooltip';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {DatePickerModule} from 'primeng/datepicker';
import {InputNumberModule} from 'primeng/inputnumber';
import {DialogModule} from 'primeng/dialog';
import {BlobUploadToolComponent} from '@webmate-web-core/shared/tools/blob-upload/blob-upload-tool.component';
import {URLModule} from '@webmate-web-core/shared/components/urls/urls.module';
import {MultiSelectModule} from 'primeng/multiselect';
import {ListboxModule} from 'primeng/listbox';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DeviceMalfunctionReporterComponent} from '@webmate-web-core/shared/tools/malfunctionreporter/device-malfunction-reporter.component';
import {DeviceSharedModule} from '@webmate-web-core/shared/components/device/device-shared.module';
import {RegressionTestDialogComponent} from '@webmate-web-core/shared/tools/regression-test/regression-test-dialog.component';
import {ScriptManagerComponent} from '@webmate-web-core/shared/tools/scriptmanager/script-manager.component';
import {PasswordModule} from 'primeng/password';
import {
    SeleniumCapabilityGeneratorComponent
} from '@webmate-web-core/shared/tools/capability-generator/selenium-capability-generator.component';
import {WmDirectivesModule} from '@webmate-web-core/shared/directives/directives.module';
import {ModalToolContainerComponent} from '@webmate-web-core/shared/tools/modaltoolcontainer/modaltoolcontainer.component';
import {ImageuploadComponent} from '@webmate-web-core/shared/tools/imageupload/imageupload.component';
import {SearchToolComponent} from '@webmate-web-core/shared/tools/searchtool/searchtool.component';
import {SearchResultComponent} from '@webmate-web-core/shared/tools/searchtool/search-result.component';
import {ScreenshotViewerComponent} from '@webmate-web-core/shared/tools/screenshotviewer/screenshotviewer.component';
import {VideoBrowserComponent} from '@webmate-web-core/shared/tools/videobrowser/video-browser.component';
import {VideoEntryComponent} from '@webmate-web-core/shared/tools/videobrowser/video-entry.component';
import {VideoViewerComponent} from '@webmate-web-core/shared/tools/video-viewer/video-viewer.component';
import {ScreenshotEntryComponent} from '@webmate-web-core/shared/tools/screenshotbrowser/screenshot-entry.component';
import {ScreenshotBrowserComponent} from '@webmate-web-core/shared/tools/screenshotbrowser/screenshot-browser.component';
import {TestComponent} from '@webmate-web-core/shared/tools/service-interfaces/test.component';
import {PaginatorModule} from 'primeng/paginator';
import {CrossbrowserTestDialogComponent} from '@webmate-web-core/shared/tools/cbt/crossbrowser-test-dialog.component';
import {SlotMalfunctionReporterComponent} from '@webmate-web-core/shared/tools/malfunctionreporter/slot-malfunction-reporter.component';
import {BillCreationToolComponent} from '@webmate-web-core/shared/tools/billcreationtool/billcreationtool.component';
import {ResourceViewsModule} from '@webmate-web-core/shared/components/resources/resource-views.module';
import {TextEditorToolComponent} from '@webmate-web-core/shared/tools/text-editor/text-editor-tool.component';
import {EditorModule} from 'primeng/editor';
import {UpdateRequestToolComponent} from '@webmate-web-core/shared/tools/updaterequest/update-request.component';
import {StartAuditDialogComponent} from "@webmate-web-core/shared/tools/audit/audit/start-audit-dialog.component";
import {ModalConfirmationToolComponent} from '@webmate-web-core/shared/tools/modal-confirmation/modal-confirmation-tool.component';
import {PopoverModule} from "primeng/popover";
import {
    NotificationEditorToolComponent
} from "@webmate-web-core/shared/tools/notification-editor/notification-editor-tool.component";
import {
    DisplayNotificationComponent
} from "@webmate-web-core/shared/components/notification/display-notification.component";
import {RouterLink} from "@angular/router";
import {AutoCompleteModule} from "primeng/autocomplete";
import {CreateAuditTemplateToolComponent} from "@webmate-web-core/shared/tools/audit/audittemplate/create-audittemplate-tool.component";
import {EditRequirementDialogComponent} from "@webmate-web-core/shared/tools/audit/audittemplate/edit-requirement-dialog.component";
import {AuditTestObjectsComponent} from "@webmate-web-core/projects/project/auditlab/audits/audit-test-objects.component";
import {ToggleSwitchModule} from 'primeng/toggleswitch';
import {DragDropModule} from "@angular/cdk/drag-drop";
import {TagsModule} from "@webmate-web-core/shared/components/tags/tags.module";
import {TabViewModule} from "primeng/tabview";
import {SpecsTreeComponent} from "@webmate-web-core/projects/project/auditlab/audits/specs-tree.component";
import {RadioButtonModule} from "primeng/radiobutton";
import {FactsModule} from "@webmate-web-core/shared/components/facts/facts.module";
import {
    ContrastTooltipViewComponent
} from "@webmate-web-core/shared/tools/contrast-analysis-view/contrast-tooltip-view/contrast-tooltip-view.component";
import {
    MagniferGlassComponent
} from "@webmate-web-core/shared/tools/contrast-analysis-view/magnifer-glass/magnifer-glass.component";
import {
    ContrastAnalysisViewComponent
} from "@webmate-web-core/shared/tools/contrast-analysis-view/contrast-analysis-view.component";
import {ImageEditorToolComponent} from "@webmate-web-core/shared/tools/screenshotviewer/image-editor.component";
import {ColorchooserComponent} from "@webmate-web-core/shared/tools/screenshotviewer/colorchooser.component";
import {AppUploadToolComponent} from '@webmate-web-core/shared/tools/app-upload/app-upload-tool.component';
import {IconField} from 'primeng/iconfield';
import {InputIcon} from 'primeng/inputicon';
import {InputGroup} from 'primeng/inputgroup';
import {InputGroupAddon} from 'primeng/inputgroupaddon';
import {WmCalendarFormatPipe} from '@webmate-web-core/shared/utils/pipes/wm-calendar-format';
import {ErrorMessagePipe} from '@webmate-web-core/shared/utils/pipes/error.pipe';
import {ChartViewerToolComponent} from '@webmate-web-core/shared/tools/chart-viewer/chart-viewer-tool.component';
import {PlotlySharedModule} from 'angular-plotly.js';
import {StartAuditAutomationToolComponent} from '@webmate-web-core/shared/tools/audit/automation/start-auditautomation-tool.component';
import {ProjectsModule} from '@webmate-web-core/projects/projects.module';
import {AuditPlanningComponent} from '@webmate-web-core/projects/project/auditlab/audits/audit-planning.component';
import {PlanningMatrixSelectionToolComponent} from '@webmate-web-core/projects/project/auditlab/audits/planningmatrix-selection-tool.component';
import {MenuModule} from 'primeng/menu';
import {ProgressBarModule} from 'primeng/progressbar';
import {DropdownModule} from "primeng/dropdown";
import {InputSwitch} from 'primeng/inputswitch';
import {FormsCommonsModule} from '@webmate-web-core/shared/components/forms-commons/forms-commons.module';
import {SpecCheckTestDialogComponent} from '@webmate-web-core/shared/tools/speccheck/spec-check-test-dialog.component';
import {SpecsSharedModule} from '@webmate-web-core/shared/components/specs/specs-shared.module';
import {AutomationPolicyEditorComponent} from '@webmate-web-core/shared/components/browsersession/automation-policy-editor.component';
import {SelectTestComponent} from '@webmate-web-core/shared/tools/select-test/select-test.component';
import {TestmgmtModule} from '@webmate-web-core/shared/components/testmgmt/testmgmt.module';
import {ManualWebsiteTestDialogComponent} from '@webmate-web-core/shared/tools/manual-website-test/manual-website-test-dialog.component';
import {BulkUserInviteComponent} from '@webmate-web-core/shared/tools/bulk-user-invite/bulk-user-invite.component';
import {TableModule} from 'primeng/table';
import {Chip} from 'primeng/chip';
import {ActivityInfoChartComponent} from '@webmate-web-core/shared/components/common/activity-info-chart.component';


@NgModule({
    declarations: [
        ArtifactComponent,
        AuditPlanningComponent,
        BlobUploadToolComponent,
        BrowsersessionViewerComponent,
        BillCreationToolComponent,
        BulkUserInviteComponent,
        ChartViewerToolComponent,
        PlanningMatrixSelectionToolComponent,
        DeviceMalfunctionReporterComponent,
        SlotMalfunctionReporterComponent,
        GenericTestDialogComponent,
        CreateAuditTemplateToolComponent,
        EditRequirementDialogComponent,
        ImageuploadComponent,
        ImageEditorToolComponent,
        IssueReporterComponent,
        ModalToolContainerComponent,
        ScreenshotArtifactComponent,
        ScriptManagerComponent,
        SeleniumActionArtifactComponent,
        StartAuditDialogComponent,
        StatedataViewerComponent,
        TextEditorToolComponent,
        RegressionTestDialogComponent,
        CrossbrowserTestDialogComponent,
        SpecCheckTestDialogComponent,
        SeleniumCapabilityGeneratorComponent,
        ModalToolContainerComponent,
        NotificationEditorToolComponent,
        ImageuploadComponent,
        SearchToolComponent,
        SearchResultComponent,
        ScreenshotViewerComponent,
        StartAuditAutomationToolComponent,
        ContrastTooltipViewComponent,
        MagniferGlassComponent,
        ContrastAnalysisViewComponent,
        VideoBrowserComponent,
        VideoEntryComponent,
        VideoViewerComponent,
        ScreenshotEntryComponent,
        ScreenshotBrowserComponent,
        TestComponent,
        UpdateRequestToolComponent,
        ModalConfirmationToolComponent,
        AppUploadToolComponent,
        SelectTestComponent,
        ManualWebsiteTestDialogComponent
    ],
    imports: [
        CommonModule,
        AuditTestObjectsComponent,
        FormsModule,
        ReactiveFormsModule,
        PortalModule,
        AccordionModule,
        SelectModule,
        MenuModule,
        ProgressBarModule,
        ProgressSpinnerModule,
        DatePickerModule,
        ScreenshotModule,
        WebmateBrowserModule,
        StateModule,
        CheckboxModule,
        FileUploadModule,
        SelectButtonModule,
        TextareaModule,
        InputTextModule,
        InputNumberModule,
        AvatarModule,
        ButtonModule,
        TooltipModule,
        FontAwesomeModule,
        DialogModule,
        URLModule,
        MultiSelectModule,
        ListboxModule,
        DeviceSharedModule,
        PasswordModule,
        WmDirectivesModule,
        PaginatorModule,
        ToggleSwitchModule,
        DragDropModule,
        PopoverModule,
        TagsModule,
        EditorModule,
        ResourceViewsModule,
        EditorModule,
        DisplayNotificationComponent,
        RouterLink,
        AutoCompleteModule,
        EditorModule,
        TabViewModule,
        SpecsTreeComponent,
        RadioButtonModule,
        FactsModule,
        ColorchooserComponent,
        IconField,
        InputIcon,
        InputGroup,
        InputGroupAddon,
        WmCalendarFormatPipe,
        ErrorMessagePipe,
        PlotlySharedModule,
        DropdownModule,
        InputSwitch,
        FormsCommonsModule,
        TableModule,
        Chip,
        ActivityInfoChartComponent,
        TestmgmtModule,
        SpecsSharedModule,
        AutomationPolicyEditorComponent,
    ],
    exports: [
        BlobUploadToolComponent,
        BrowsersessionViewerComponent,
        BillCreationToolComponent,
        GenericTestDialogComponent,
        ImageEditorToolComponent,
        DeviceMalfunctionReporterComponent,
        SlotMalfunctionReporterComponent,
        IssueReporterComponent,
        ScriptManagerComponent,
        StatedataViewerComponent,
        TextEditorToolComponent,
        RegressionTestDialogComponent,
        CrossbrowserTestDialogComponent,
        SeleniumCapabilityGeneratorComponent,
        SpecCheckTestDialogComponent,
        ModalToolContainerComponent,
        NotificationEditorToolComponent,
        ImageuploadComponent,
        SearchToolComponent,
        SearchResultComponent,
        ScreenshotViewerComponent,
        StartAuditAutomationToolComponent,
        VideoBrowserComponent,
        VideoEntryComponent,
        VideoViewerComponent,
        ScreenshotEntryComponent,
        ScreenshotBrowserComponent,
        TestComponent,
        ModalConfirmationToolComponent,
        ArtifactComponent,
        ContrastAnalysisViewComponent,
        AppUploadToolComponent,
        AuditPlanningComponent,
        BulkUserInviteComponent,
        PlanningMatrixSelectionToolComponent,
        SelectTestComponent,
    ],
})
export class ToolsModule {
}
